import * as React from 'react';
import { Button, Empty } from 'antd';

import { getLangKey } from 'models/Language';

import * as translations from './strings';
import styles from './index.module.css';

export type Props = {
  hiddenProjectsCount: number;
  onViewAllProjects: () => void;
};

export const HiddenProjectsNotice: React.FC<Props> = ({
  hiddenProjectsCount,
  onViewAllProjects
}) => {
  const strings = translations[getLangKey()];

  return (
    <div className={styles.hiddenProjectsNotice}>
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={strings.projectsHiddenByFilters(hiddenProjectsCount)}
      >
        <Button type="primary" shape="round" onClick={onViewAllProjects}>
          {strings.viewAllProjects}
        </Button>
      </Empty>
    </div>
  );
};
